var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPhone = function SvgPhone(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M7.153 2.747a1.246 1.246 0 0 0-1.481-.725l-2.75.75C2.378 2.922 2 3.416 2 3.978c0 7.731 6.268 14 14 14 .562 0 1.056-.379 1.206-.922l.75-2.75a1.246 1.246 0 0 0-.725-1.481l-3-1.25a1.25 1.25 0 0 0-1.447.362l-1.263 1.54A10.56 10.56 0 0 1 6.5 8.457l1.54-1.26c.428-.35.575-.937.363-1.446l-1.25-3z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export default ForwardRef;